import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SHARE_REPORT_WHATSAPP } from '@custom/constant';
import { ShareReportParams } from '@custom/Utils/constants/interfaces';

export const shareReportWhatsapp = createAsyncThunk(
  'reports/shareReportWhatsapp',
  async (params: ShareReportParams, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await axios.post(
        `${SHARE_REPORT_WHATSAPP}`,
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error sharing report via WhatsApp');
    }
  }
);
